import type { StatusTone } from '@/components/ui';
import { ApiError } from './api/client';

export function errorMessage(
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
): string {
  if (error instanceof ApiError) return error.message;
  return fallback;
}

export function errorRequestId(error: unknown): string | null {
  return error instanceof ApiError ? error.requestId : null;
}

export function humanize(value: string): string {
  return value
    .replace(/[_.-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^\w/, (c) => c.toUpperCase());
}

export const STATUS_TONES: Record<string, StatusTone> = {
  active: 'success',
  pending: 'info',
  planning: 'info',
  accepted: 'success',
  inactive: 'neutral',
  closed: 'neutral',
  archived: 'neutral',
  expired: 'warning',
  suspended: 'warning',
  revoked: 'danger',
  disabled: 'danger',
  success: 'success',
  failure: 'warning',
  denied: 'danger',
};

export function statusTone(status: string): StatusTone {
  return STATUS_TONES[status] ?? 'neutral';
}

export const SCHOOL_TYPES = [
  { value: 'early_childhood', label: 'Early childhood' },
  { value: 'elementary', label: 'Elementary' },
  { value: 'middle', label: 'Middle' },
  { value: 'high', label: 'High' },
  { value: 'k8', label: 'K-8' },
  { value: 'k12', label: 'K-12' },
  { value: 'alternative', label: 'Alternative' },
  { value: 'virtual', label: 'Virtual' },
  { value: 'career_technical', label: 'Career & technical' },
  { value: 'special_education', label: 'Special education' },
  { value: 'other', label: 'Other' },
];

export const GRADES = [
  'PK',
  'TK',
  'K',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  'PG',
];

export function gradeSpan(lowest: string | null, highest: string | null): string {
  if (!lowest && !highest) return '—';
  if (lowest === highest) return lowest ?? '—';
  return `${lowest ?? '?'}–${highest ?? '?'}`;
}
